import {Box} from "@mui/material";

const ComingSoon = () => {
    return (
        <Box>Coming Soon!</Box>
    )
}

export default ComingSoon;